export const SET_POPUP = 'SET_POPUP';

export const setPopup = (data) => {
	return {
		type: SET_POPUP,
		payload: data,
	};
};